module.exports = __webpack_public_path__ + "static/img/s08.e22cf201.png";